import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'danger-outline'
  size?: 'sm' | 'md' | 'lg'
  fullWidth?: boolean
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles =
    'inline-flex items-center justify-center rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400 disabled:border-gray-200 disabled:shadow-none disabled:hover:bg-gray-200 disabled:hover:text-gray-400 disabled:hover:border-gray-200 disabled:hover:shadow-none'

  const variantStyles = {
    primary:
      'bg-primary text-white hover:bg-primary-hover focus:ring-primary shadow-sm hover:shadow-md',
    secondary:
      'bg-secondary text-gray-900 hover:bg-secondary-hover focus:ring-secondary shadow-sm hover:shadow-md',
    outline:
      'border-2 border-gray-300 text-gray-700 hover:border-primary hover:text-primary focus:ring-primary bg-white',
    danger: 'bg-danger text-white hover:bg-red-700 focus:ring-danger shadow-sm hover:shadow-md',
    'danger-outline':
      'border-2 border-danger text-danger hover:bg-danger hover:text-white focus:ring-danger bg-white',
  }

  const sizeStyles = {
    sm: 'px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm md:px-5 md:py-2.5',
    md: 'px-4 py-2 text-sm sm:px-5 sm:py-2.5 sm:text-base md:px-6 md:py-3',
    lg: 'px-5 py-2.5 text-base sm:px-6 sm:py-3 md:px-8 md:py-3.5 md:text-lg',
  }

  const widthStyle = fullWidth ? 'w-full' : ''

  return (
    <button
      data-component-name="Button"
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
